import { QRCodeCanvas } from 'qrcode.react'
import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useParams } from 'react-router-dom'
import { qrSelector } from '../../../redux/slices/qr'
import ButtonDownload from '../../reusable/Buttons/ButtonDownload'
import CountdownTime from '../../reusable/Dayjs/CountdownTime'
import Hdivider from '../../reusable/Dividers/Hdivider'
import KeyValueInfo from '../../reusable/Info/KeyValueInfo'
import QrId from '../../reusable/Qr/QrId'

const QrTicketInfo = () => {
  const qrRef = useRef(null)
  const { ticket_id } = useParams()
  const { orders } = useSelector(qrSelector)
  const ticketData = orders.find((t) => t.id === ticket_id)
  if (!ticketData) return <Navigate to="/qr/tickets" />
  const { qr_data, city, transport, route_id, purchaseDate, sum, timeLeft } = ticketData
  // const isAlmostExpired = false // true

  const handleDownload = () => {
    const canvas = qrRef.current
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')

    const downloadLink = document.createElement('a')
    downloadLink.href = pngUrl
    downloadLink.download = `qr-${ticket_id}.png`
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }

  return (
    <div className="qr_ticket_info">
      <QrId id={ticket_id} noHandler />

      <QRCodeCanvas // make sure it's canvas for easier export
        value={qr_data}
        size={185}
        marginSize={1}
        ref={qrRef}
        className="qr_code"
      />
      {/* <img className="qr_code" src="/img/qr_example.png" alt="" /> */}

      <div className="qr_data">
        <KeyValueInfo infoKey="Місто" infoValue={city} />
        <KeyValueInfo infoKey="Транспорт" infoValue={transport} />
        <KeyValueInfo infoKey="Маршрут" infoValue={route_id} />
        <Hdivider />
        <KeyValueInfo infoKey="Дата придбання" infoValue={purchaseDate} />
        <KeyValueInfo infoKey="Вартість" infoValue={sum + ' UAH'} />
        <Hdivider />
        <KeyValueInfo
          infoKey="Залишилось"
          infoValue={<CountdownTime timestamp={timeLeft} />}
          spaceBtw
          // redValue={isAlmostExpired}
          boldValue
        />
      </div>
      <ButtonDownload handler={handleDownload} />
    </div>
  )
}

export default QrTicketInfo
